import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';

import { UnidadeMedidaService } from '@app/modules/produto/services/produto-fiscal-service/unidade_medida.service';
import { IUnidade } from '@app/modules/unidade/model/unidade.model';
import { UnidadeService } from '@app/modules/unidade/services';
import { Utils } from '@app/shared/helpers/utils';

@Component({
  selector: 'app-fast-unidade',
  templateUrl: './fast-unidade.component.html',
  styleUrls: ['./fast-unidade.component.scss'],
  providers: [UnidadeService, UnidadeMedidaService]
})
export class FastUnidadeComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  displayMessages = {
    nome: {
      required: 'O nome é obrigatório',
      maxlength: 'Não pode ter mais de 30 caracteres',
      repeated: 'Este nome já está em uso.',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    sigla: {
      required: 'A unidade é obrigatória',
      repeated: 'Esta sigla já está em uso.',
      maxlength: 'Não pode ter mais de 3 caracteres.'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<FastUnidadeComponent>,
    private formBuilder: UntypedFormBuilder,
    public entityService: UnidadeService,
    public tokenService: TokenService,
    public unidadeMedidaService: UnidadeMedidaService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private data: { entity: IUnidade }
  ) {}

  ngOnInit(): void {
    const { entity } = this.data;
    this.form = this.formBuilder.group(
      this.usaFiscal
        ? {
            sigla: [null, [Validators.required, Validators.maxLength(3)]],
            nome: [
              null,
              [
                Validators.required,
                Validators.maxLength(30),
                CustomValidators.isEmptyValue()
              ]
            ],
            fracionado: [false],
            unidade_medida: [
              null,
              [
                Validators.required,
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ]
          }
        : {
            sigla: [null, [Validators.required, Validators.maxLength(3)]],
            nome: [
              null,
              [
                Validators.required,
                Validators.maxLength(30),
                CustomValidators.isEmptyValue()
              ]
            ],
            fracionado: [false]
          }
    );
  }

  public verificarSigla(): void {
    const control = this.form.controls.sigla;

    if (control.invalid) return;
    const sigla = control.value as string;

    this.entityService
      .getEntitiesByParams({
        where: {
          sigla: sigla.toUpperCase(),
          domain_id: this.tokenService.getDomain().id
        }
      })
      .subscribe(result => {
        if (!result || !result.length) return;

        control.setErrors({ repeated: true });
      });
  }

  public verificarNome(): void {
    const control = this.form.controls.nome;

    if (control.invalid) return;
    const nome = control.value as string;

    this.entityService
      .getEntitiesByParams({
        where: {
          nome,
          domain_id: this.tokenService.getDomain().id
        }
      })
      .subscribe(result => {
        if (!result || !result.length) return;

        control.setErrors({ repeated: true });
      });
  }

  public submit(): void {
    if (!this.form.valid) return;

    this.loading = true;
    const { value } = this.form;
    value.sigla = value.sigla.toUpperCase();
    var entity = { domain_id: this.tokenService.getDomain().id, ...value };
    entity = Utils.trimAttributes(entity);

    if(entity.unidade_medida){
      entity.unidade_medida_id = entity.unidade_medida.id;
      delete entity.unidade_medida;
    }

    this.entityService.insert(entity).subscribe(
      unidade => {
        if (unidade) {
          this.matSnackBar.open(`Unidade cadastrado com sucesso.`, 'X', {
            duration: 2000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['msg-success']
          });
          this.dialogRef.close(unidade);
        }
      },
      () => {
        this.matSnackBar.open(`Erro ao cadastrar unidade.`, 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-error']
        });
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  get usaFiscal() {
    return localStorage.getItem('usaFiscal') === 'true';
  }
}
